import { render } from "./AddAnnonces.vue?vue&type=template&id=81e999c8&scoped=true"
import script from "./AddAnnonces.vue?vue&type=script&lang=js"
export * from "./AddAnnonces.vue?vue&type=script&lang=js"

import "./AddAnnonces.vue?vue&type=style&index=0&id=81e999c8&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81e999c8"]])

export default __exports__